import { Box } from '@mui/material';
import { useTranslate } from 'react-admin';
import { TAB_LABELS } from '../mock-data';
import type { DashboardV3TabValue } from '../main-page';

interface DashboardV3TopTabsProps {
  activeTab: DashboardV3TabValue;
  onChange: (tab: DashboardV3TabValue) => void;
}

export function DashboardV3TopTabs({ activeTab, onChange }: DashboardV3TopTabsProps) {
  const t = useTranslate();

  return (
    <>
      {TAB_LABELS.map((tab) => {
        const active = activeTab === tab.value;

        return (
          <Box
            key={tab.value}
            onClick={() => onChange(tab.value)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: 120,
              height: 48,
              px: 2,
              fontSize: 14,
              fontWeight: 500,
              letterSpacing: '1.25px',
              textTransform: 'uppercase',
              color: active ? '#BB86FC' : 'rgba(187,134,252,0.6)',
              cursor: 'pointer',
              position: 'relative',
              userSelect: 'none',
              whiteSpace: 'nowrap',
              '&:hover': { background: 'rgba(187,134,252,0.08)' },
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                height: 2,
                bgcolor: '#BB86FC',
                transform: active ? 'scaleX(1)' : 'scaleX(0)',
                transformOrigin: 'center',
                transition: 'transform .2s',
              },
            }}
          >
            {t(tab.labelKey, { _: tab.labelKey })}
          </Box>
        );
      })}
    </>
  );
}